import { PaymentProduct, UsdtNetwork } from '../api/api';

const SUPPORTED_PRODUCTS = new Set(['USDT:TRC20', 'USDT:BEP20', 'USDT:ERC20', 'ETH:ETHEREUM']);

const NETWORK_META: Record<string, { name: string; placeholder: string; hint: string }> = {
  TRC20: {
    name: 'TRON',
    placeholder: 'T...',
    hint: 'Адрес должен начинаться с T и поддерживать сеть TRON.',
  },
  BEP20: {
    name: 'BNB Smart Chain',
    placeholder: '0x...',
    hint: 'Адрес должен начинаться с 0x и поддерживать BNB Smart Chain.',
  },
  ERC20: {
    name: 'Ethereum',
    placeholder: '0x...',
    hint: 'Адрес должен начинаться с 0x и поддерживать Ethereum.',
  },
  ETHEREUM: {
    name: 'Ethereum',
    placeholder: '0x...',
    hint: 'Адрес должен начинаться с 0x и поддерживать Ethereum.',
  },
};

const TRON_ADDRESS = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
const EVM_ADDRESS = /^0x[a-fA-F0-9]{40}$/;

export interface PaymentNetworkOption {
  asset: string;
  network: UsdtNetwork;
  label: string;
  description: string;
  placeholder: string;
  hint: string;
  liquidity: number | null;
  liquidityError: string | null;
}

export function productLiquidity(product: PaymentProduct): number | null {
  const value = product.available_liquidity
    ?? product.availableLiquidity
    ?? product.liquidity
    ?? null;

  return typeof value === 'number' && Number.isFinite(value) ? value : null;
}

export function buildPaymentNetworkOptions(products: PaymentProduct[]): PaymentNetworkOption[] {
  const seen = new Set<string>();
  return products
    .map(product => {
      const asset = product.asset?.trim().toUpperCase();
      const network = product.network?.trim().toUpperCase();
      const key = `${asset}:${network}`;
      if (!SUPPORTED_PRODUCTS.has(key)) return null;
      if (seen.has(key)) return null;
      seen.add(key);

      const meta = NETWORK_META[network] ?? {
        name: network,
        placeholder: '',
        hint: 'Укажите адрес кошелька в выбранной сети.',
      };

      return {
        asset,
        network,
        label: asset === 'ETH' ? 'ETH' : network,
        description: meta.name,
        placeholder: meta.placeholder,
        hint: meta.hint,
        liquidity: productLiquidity(product),
        liquidityError: product.liquidity_error ?? product.liquidityError ?? null,
      };
    })
    .filter((option): option is PaymentNetworkOption => option != null);
}

export function validateWalletAddress(network: UsdtNetwork, address: string): boolean {
  const value = address.trim();
  if (!value) return false;
  const normalized = network.trim().toUpperCase();
  if (normalized === 'TRC20') return TRON_ADDRESS.test(value);
  if (normalized === 'BEP20' || normalized === 'ERC20' || normalized === 'ETHEREUM') return EVM_ADDRESS.test(value);
  return false;
}
